module.exports = __webpack_public_path__ + "5a778b78cfe07e292d05a3c4442fdcd1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/GoldenCityapp.jpg
// module id = 564
// module chunks = 0